<template>
	<div>
		<!-- <ul class="dropdown" v-if="show_sublist.includes(index)&&custom_li.subgroups && custom_li.subgroups.length > 0"> -->
			<li 
			>
				<p :class="{'selected_item_parent': selected_id.includes(custom_sub)}" @click="selectItem(custom_sub)">{{custom_sub.name}}</p><a class="open-icon" v-if="hasSubGroups(custom_sub)" @click="openSubTab_(index_)"  :class="{'rotate-90': show_sublist_.includes(index_)}">&#9656;</a>
				<ul class="dropdown" v-if="show_sublist_.includes(index_)&&custom_sub.subgroups && custom_sub.subgroups.length > 0">
					 <recursion-list v-for="(custom_sub_,index_) in custom_sub.subgroups" :custom_sub="custom_sub_" @selectItem="selectItem" :selected_id="selected_id" :index="index_" :key="index_"/>
					<!-- <li  v-for="(custom_sub_,index_) in custom_sub.subgroups" :key="index_"
					>
						<p :class="{'selected_item_parent': selected_id.includes(custom_sub_)}" @click="selectItem(custom_sub_)">{{custom_sub_.name}}</p>
					</li> -->
				</ul>
			</li>
		<!-- </ul> -->
	</div>
</template>
<script>
export default {
	name: "recursionList",
	props:["custom_sub","selected_id","index_"]
	,
	computed : {
	
	},
	data : function(){
		return{
			show_list: true,
			show_sublist: [],
			show_sublist_:[]
		}
	},
	methods:{
		openTab(){
			this.show_list = !this.show_list
		},
		openSubTab(elem){
			if(this.show_sublist.includes(elem)){
				this.show_sublist = this.show_sublist.filter(function(value, index){ 
					return value !=  elem;
				});
			}else{
				this.show_sublist.push(elem)
			}
		},
		selectItem(elem){
			this.$emit("selectItem", elem)
		},
		hasSubGroups(elem){
			return elem.subgroups && elem.subgroups.length >0
		},
		openSubTab_(elem){
			if(this.show_sublist_.includes(elem)){
				this.show_sublist_ = this.show_sublist_.filter(function(value, index){ 
					return value !=  elem;
				});
			}else{
				this.show_sublist_.push(elem)
			}
		}
	},
	created : function(){
	}
	
}
</script>

<style scoped src="../shared/assets/css/groupAccessList.css">

</style>



// WEBPACK FOOTER //
// src/components/shared/recursionList.vue